import { api } from "../../axios";

export const actions = {

    //Api
    GetApiByTarget(context, data){
        return api.get(`Api/target/${data.targetId}/${data.opcrId}`);
    },
    GetApiByOpcr(context, data){
        return api.get(`Api/Opcr/${data}`);
    },
    GetAllApis(context, data){
        return api.get(`Api/All/Summary/${data}`);
    },
    GetSingleApi(context, data){
        return api.get(`Api/${data}`);
    },
    GetPostedApi(context, data){
        return api.get(`Api/posted/${data.cycle}/${data.campusId}`);
    },
    GetApprovedApi(context, data){
        return api.get(`Api/approved/${data.cycle}/${data.campusId}`);
    },
    GetBackLogs(context, data){
        return api.get(`Api/BackLog/${data}`);
    },
    GetApiLogs(context, data){
        return api.get(`Api/Log/${data}`);
    },
    UpdateApi(context, data){
        return api.put(`Api/${data.id}`, data);
    },
    DeleteApi(context, data){
        return api.delete(`Api/${data}`);
    },
    CreateApi(context, data){
        return api.post(`Api/CreateApi`, data);
    },
    PostApi(context, data){
        return api.put(`Api/post/${data}`);
    },
    ApproveApi(context, data){
        return api.put(`Api/approve/${data}`);
    },
    ReturnApi(context, data){
        return api.put(`Api/Return/${data.id}?remarks=${data.remarks}`);
    },
    ReturnApiPlanning(context, data){
        return api.put(`Api/Planning/Return/${data.id}?remarks=${data.remarks}`);
    },
    GetApiOfficeBudgetItem(context, data) {
        return api.get(`Api/BudgetLineItem/${data}`);
    },
    UpdateBL(context, data) {
        return api.put(`Api/BackLog/${data.id}?status=${data.status}`);
    },
    ImportPreplanningApi(context, data) {
        return api.post(`Api/Import`, data);
    },
    GetApprovedProcurable(context, data) {
        return api.get(`Api/Approved/Procurable/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetAllApisByDepartment(context, data) {
        return api.get(`Api/All/Summary/${data.opcrId}/${data.departmentId}`);
    },
    GetApisByIndicatorItem(context, data) {
        return api.get(`Actual/DeliveryUnit/${data.deliveryUnitId}/IndicatorItem/${data.indicatorItemId}/Cycle/${data.cycle}`);
    }
}